export default __webpack_public_path__ + "static/media/14@3x.7b2214e4.png";